/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isObject } from 'lodash';

// Components
import Dialog from 'shared/ui/components/modals/DialogComponent.vue';
import ListActions from 'shared/ui/components/listings/ListActions.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';
import SearchBar from 'shared/ui/components/form-components/SearchBar.vue';
import SmartTable from 'shared/ui/components/tables/SmartTable.vue';

import TitleCell from 'ui/components/meetings/TitleCell.vue';
import OrganizerCell from 'ui/components/meetings/OrganizerCell.vue';
import StatusCell from 'ui/components/meetings/StatusCell.vue';
import DateCell from 'ui/components/meetings/DateCell.vue';
import ParticipantsCell from 'ui/components/meetings/ParticipantsCell.vue';

const __vue_script__ = {
    name: 'MeetingsList',

    components: {
        ListActions,
        LoaderButton,
        SearchBar,
        SmartTable
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            cols: [],
            currentPage: 1,
            eid: this.params.event._id,
            loading: false,
            metadata: {},
            processing: false,
            rows: [],
            searchTerm: '',
            sort: 'ASC',
            sortField: null,
            total: null,
            itemsPerPage: this.$services.meetings.MAX_MEETINGS_PER_PAGE
        };
    },

    watch: {
        searchTerm() {
            this.loadData();
        }
    },

    async created() {
        this.metadata = await this.$services.metadata.getMetadataForType(this.eid, 'meeting');
        this.cols = this.getColsConfig();
        this.loadData();
    },

    methods: {
        /**
         * Loads the collection to display on the table
         *
         * @param {number} page the page to load
         */
        async loadData(page = this.currentPage) {
            try {
                if (this.loading) {
                    return;
                }

                this.loading = true;

                const crudOpts = get(this.params, 'currentController.resolvers.default.options');
                const params = {
                    crudOpts,
                    page,
                    sort: this.sort,
                    sortField: this.sortField,
                    search: this.searchTerm
                };

                this.itemsPerPage = crudOpts.itemsPerPage || this.itemsPerPage;

                const { rows, total } = await this.$services.meetings.getAll(this.eid, this.$services, params);

                this.rows = rows;
                this.total = total;
                this.currentPage = page;

            } catch (error) {
                console.error('[MeetingsList] Could not load data', error.message);
                this.flashError(this.$i18n.t('general.try_later'));
            } finally {
                this.loading = false;
            }
        },

        /**
         * Flashes an error message
         *
         * @param {string} text the error message to display
         */
        flashError(text) {
            this.$notify({
                group: 'flashes',
                title: this.$i18n.t('general.error_occurred').toString(),
                text,
                type: 'error',
                duration: 5000
            });
        },

        /**
         * @returns {object[]} each column configuration
         */
        getColsConfig() {
            const cols = [
                {
                    field: 'title',
                    label: 'meetings.details.title',
                    sortable: 'title',
                    component: TitleCell
                },
                {
                    field: 'organizer',
                    label: 'meetings.details.organized_by',
                    component: OrganizerCell
                },
                {
                    field: 'start_ts',
                    label: 'meetings.details.date_and_time',
                    sortable: 'start_ts',
                    component: DateCell
                },
                {
                    field: 'meeting_location',
                    format: item => item.location,
                    link: this.$utils.modules.getNamedRoute(this.params.module, 'view-location')
                },
                {
                    field: 'participants',
                    component: ParticipantsCell
                },
                {
                    field: 'status',
                    label: 'meetings.details.status',
                    component: StatusCell
                },
                {
                    field: 'acceptance',
                    label: 'meetings.details.acceptance',
                },
                {
                    field: 'attendance',
                    label: 'meetings.details.attendance'
                }
            ];

            for (const col of cols) {
                const meta = this.metadata[col.field];

                let label = col.field;
                if (isObject(meta) && meta.hasOwnProperty('label')) {
                    label = meta.label;
                }

                col.label = col.label || label;
            }

            return cols;
        },

        /**
         * Compiles a link in the context of the given cell
         *
         * @param {object} cellConfig the configuration for the cell
         * @param {object} item the FP typed item
         *
         * @returns {string} a compiled version of the link for this cell
         */
        cellLink(cellConfig, item) {
            if (!cellConfig.link) {
                return null;
            }

            if (cellConfig.field === 'meeting_location' && !item.meeting_location) {
                return null;
            }

            const params = {
                eventId: this.eid,
                _id: item._id
            };

            if (item.meeting_location?.length) {
                params._id = item.meeting_location;
            }

            return this.$utils.url.interpolateUrl(cellConfig.link, params);
        },

        /**
         * Sets the sortable field and reload the collection
         *
         * @param {object} cellConfig the configuration for the cell
         */
        setSortable(cellConfig) {
            const { sort, sortField } = this.$utils.tables.setSortable(cellConfig, this.sort, this.sortField);
            this.sort = sort;
            this.sortField = sortField;
            this.loadData();
        },

        /**
         * Prompts the user to confirm meetings deletion.
         */
        deleteMeetings() {
            const selectedMeetings = this.$refs.meetings.selectedItems;
            this.$modal.show(Dialog, {
                title: this.$tc('listings.actions.meetings_deletion', selectedMeetings.length),
                text: this.$tc('listings.messages.meetings_deletion_prompt', selectedMeetings.length),
                alert: this.$t('listings.actions.meetings_deletion_alert'),
                closeOnHeader: true,
                buttons: [
                    {
                        title: this.$t('general.dismiss'),
                        default: true,
                        closeOnClick: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('listings.actions.meetings_deletion_without_notify'),
                        handler: () => this.delete(selectedMeetings, false),
                        closeOnClick: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('listings.actions.meetings_deletion_and_notify'),
                        handler: () => this.delete(selectedMeetings),
                        closeOnClick: true,
                        class: 'btn btn-danger'
                    }
                ]
            });
        },

        /**
         * Deletes meetings.
         *
         * @param {Array} meetings - The array of meetings to be deleted.
         * @param {Boolean} [notify=true]
         */
        async delete(meetings, notify = true) {
            try {
                if (this.processing) {
                    return;
                }

                this.processing = true;
                console.info('[MeetingsList] Deleting meetings', meetings);
                const ids = meetings.map(_row => _row._id);
                const appscript = get(this.params, 'currentController.routeOptions.crudOpts.actions.delete.appscriptUrl');

                if (!appscript) {
                    throw new Error('No delete appscript found');
                }

                await this.$services.appScripts.callAppScript(this.eid, appscript, { ids, notify });

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.messages.deleted_success').toString(),
                    type: 'success',
                    duration: 5000
                });
                this.$refs.meetings.unselectAll();
                await this.loadData();
            } catch (error) {
                this.flashError(this.$i18n.t('general.try_later'));
            } finally {
                this.processing = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"meetings-list fp-typed-list"},[_c('smart-table',{ref:"meetings",attrs:{"track-by":"_id","hide-pagination":_vm.searchTerm.length > 0,"items-per-page":_vm.itemsPerPage,"items":_vm.rows,"selectable":true,"total-items":_vm.total || _vm.rows.length},on:{"next":_vm.loadData,"previous":_vm.loadData,"select-page":_vm.loadData},scopedSlots:_vm._u([{key:"filters",fn:function(ref){return [_c('search-bar',{attrs:{"show-no-result":false},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})]}},{key:"actions",fn:function(ref){return [_c('list-actions',{attrs:{"controller":_vm.params.currentController,"module":_vm.params.module,"event":_vm.params.event,"metadata":_vm.metadata},on:{"reload":_vm.loadData}})]}},{key:"bulk-actions",fn:function(ref){return [_c('loader-button',{staticClass:"btn-danger",attrs:{"status":_vm.processing},on:{"click":function($event){return _vm.deleteMeetings()}}},[_vm._v(_vm._s(_vm.$t('listings.actions.delete')))])]}},{key:"headers",fn:function(ref){return _vm._l((_vm.cols),function(c){return _c('th',{class:[c.cssClass || c.field ].concat( _vm.$utils.tables.getCellSortClass(c, _vm.sort, _vm.sortField)),on:{"click":function($event){return _vm.setSortable(c)}}},[_c('span',[_vm._v(_vm._s(_vm.$te(c.label) ? _vm.$t(c.label) : c.label))]),_c('i',{staticClass:"ic-icon"})])})}},{key:"row",fn:function(ref){
var item = ref.item;
return _vm._l((_vm.cols),function(c){return _c('td',{class:_vm.$utils.tables.cellClasses(c, item)},[(c.component)?_c(c.component,{tag:"component",attrs:{"meeting":item,"module":_vm.params.module,"event":_vm.params.event}}):[(_vm.cellLink(c, item))?_c('a',{attrs:{"href":_vm.cellLink(c, item)}},[_vm._v(_vm._s(_vm.$utils.tables.render(c, item)))]):_c('span',[_vm._v(_vm._s(_vm.$utils.tables.render(c, item)))])]],2)})}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MeetingsList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__